module.exports = "/_next/static/images/WhatIsCyberInsuranceBgWavesRight3-59a88ab8ede80418d597623ed4fdf68d.svg";